import {useMemo} from 'react';

const useAudio = (src: string) => {
  const audio = useMemo(() => new Audio(src), [src]);

  return audio;
};

export default useAudio;
